document.addEventListener('DOMContentLoaded', function() {
  const formAndButtonWrapper = document.getElementById('form-and-button-wrapper');
  const form = document.getElementById('become-member-form');
  const signupBtn = document.getElementById('signup-btn');
  const signUpStatus = document.getElementById('signup-status');
  const success = document.getElementById('become-member-success');
  form.addEventListener('submit', async function(e) {
    e.preventDefault();
    document.querySelectorAll('.error-message').forEach(function(el) { el.textContent = ''; el.classList.remove('show'); });
    let valid = true;

    // Validate fields (frontend)
    const firstName = document.getElementById('first_name').value.trim();
    if (!firstName.match(/^[A-Za-z]{2,200}$/)) {
      let error_first_name = document.getElementById('error-first-name')
      error_first_name.textContent = 'Enter a valid first name.';
      error_first_name.classList.add('show');
      valid = false;
    }
    const lastName = document.getElementById('last_name').value.trim();
    if (!lastName.match(/^[A-Za-z]{2,200}$/)) {
      let error_last_name = document.getElementById('error-last-name')
      error_last_name.textContent = 'Enter a valid last name.';
      error_last_name.classList.add('show');
      valid = false;
    }
    const age = parseInt(document.getElementById('age').value, 10);
    if (!age || isNaN(age) || age < 1 || age > 150) {
      let error_age = document.getElementById('error-age')
      error_age.textContent = 'Enter a valid age.';
      error_age.classList.add('show');
      valid = false;
    }
    const phone = document.getElementById('phone').value.trim();
    if (!/^[0-9()+\- ]{10,20}$/.test(phone)) {
      let error_phone = document.getElementById('error-phone')
      error_phone.textContent = 'Enter a valid phone number.';
      error_phone.classList.add('show');
      valid = false;
    }
    let email = document.getElementById('email').value.trim() || "";
    if (!valid) return;
    email = email.toLowerCase()
    // Show loading spinner
    const originalBtnContent = signupBtn.innerHTML;
    signupBtn.disabled = true;
    signupBtn.innerHTML = '<span class="loading-spinner" style="display:inline-block;width:18px;height:18px;border:2px solid #fff;border-top:2px solid #222;border-radius:50%;animation:spin 1s linear infinite;vertical-align:middle;margin-right:8px;"></span>Signing Up...';

    try {
      // Send to Supabase Edge Function
      // https://rwapokmfnmvmpermypeq.supabase.co/functions/v1/create-member
      const res = await fetch('https://puyxnnhawrvntewaejns.supabase.co/functions/v1/create-member', {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ3YXBva21mbm12bXBlcm15cGVxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY0NTU0NzEsImV4cCI6MjA3MjAzMTQ3MX0.R4YEl_JCtpSW_CYfzJO6A-jB1L4pAm4j1U6QYxTJOzA'
        },
        body: JSON.stringify({ firstName, lastName, age, phone, email })
      });
      const data = await res.json();
      if (res.ok && data.success) {
        formAndButtonWrapper.classList.add('hide');
        success.classList.add('show');
      } else {
        if (data.errors) {
          Object.keys(data.errors).forEach(function(key) {
            const el = document.getElementById('error-' + key.replace(/_/g, '-'));
            if (el) {el.textContent = data.errors[key]; el.classList.add('show');};
          });
        }
        signUpStatus.textContent = data.message || 'Sign up failed.';
      }
    } catch (err) {
      console.log(err)
      signUpStatus.textContent = 'An error occurred. Please try again.';
    } finally {
      signupBtn.disabled = false;
      signupBtn.innerHTML = originalBtnContent;
    }
  });
});